import * as React from 'react';
import './order-detail.scss';
import { Modal } from 'components/modal/modal';
import { CopyablePhone, UserLink } from 'components';
import { ToIranCurrency } from 'core/utils/decimalExtentions';
import { Badge } from 'components/badge/badge';
import { Order, OrderDetail } from '../../../../../core/domain/orders-transactions/order';
import moment from 'jalali-moment';
import { Spin } from 'antd';
import { getOrderDetailByTrackingCode } from '../../../../../core/repositories/orders-transactions';
import { CheckCircleTwoTone, CloseCircleTwoTone, CopyOutlined } from '@ant-design/icons';
import { copyToClipboard } from '../../../../../core/utils/copyToClipboard';
import Countdown from 'antd/lib/statistic/Countdown';

interface Props {
    isOpen: boolean;
    setIsOpen: React.Dispatch<React.SetStateAction<boolean>>;
    trackingId: string;
    selectedRow: Order;
}

export const OrderDetailModal: React.FC<Props> = ({ isOpen, setIsOpen, trackingId, selectedRow }) => {
    const [loading, setLoading] = React.useState(false);
    const [order, setOrder] = React.useState<OrderDetail>();
    const [timer, setTimer] = React.useState<any>(0);
    const txId = order?.withdrawal?.txId || order?.deposit?.txId || order?.txid;

    const fetchOrderDetailByTrackingCode = async () => {
        if (isOpen == true) await getOrderDetailByTrackingCode(setLoading, setOrder, setTimer, trackingId);
    };

    React.useEffect(() => {
        fetchOrderDetailByTrackingCode();
    }, [isOpen]);

    return (
        <Modal className="pmx-order-track-detail" isOpen={isOpen} setIsOpen={setIsOpen}>
            {loading ? (
                <Spin spinning={loading} />
            ) : (
                <>
                    <h3>جزئیات سفارش</h3>
                    <div className="row">
                        <span>کد پیگیری</span>
                        <p className=" en">
                            <CopyOutlined onClick={() => copyToClipboard(order?.trackingCode, 'کد پیگیری')} />
                            {order?.trackingCode}
                        </p>
                    </div>
                    {order?.deposit?.trackingCode && (
                        <div className="row">
                            <span>کد پیگیری واریز</span>
                            <p className="en">
                                <CopyOutlined onClick={() => copyToClipboard(order?.deposit?.trackingCode, 'کد پیگیری واریز')} />
                                {order?.deposit?.trackingCode}
                            </p>
                        </div>
                    )}
                    {order?.withdrawal?.trackingCode && (
                        <div className="row">
                            <span>کد پیگیری برداشت</span>
                            <p className="en">
                                <CopyOutlined onClick={() => copyToClipboard(order?.withdrawal?.trackingCode, 'کد پیگیری برداشت')} />
                                {order?.withdrawal?.trackingCode}
                            </p>
                        </div>
                    )}
                    <div className="row">
                        <span>ارز مبدا</span>
                        <p className=" en">{order?.sourceSymbol}</p>
                    </div>
                    <div className="row">
                        <span>ارز مقصد</span>
                        <p className=" en">{order?.destinationSymbol}</p>
                    </div>
                    <div className="row">
                        <span>مقدار واریزی</span>
                        <p>
                            {order?.sourceSymbol === 'IRT' ? ToIranCurrency(order?.sourceAmount) : order?.sourceAmount}
                        </p>
                    </div>
                    <div className="row">
                        <span>مقدار دریافتی</span>
                        <p>
                            {order?.destinationSymbol === 'IRT'
                                ? ToIranCurrency(order?.destinationAmount)
                                : order?.destinationAmount}
                        </p>
                    </div>

                    {order?.voucher && (
                        <div className="row">
                            <span>کد ووچر</span>
                            <p>{order?.voucher}</p>
                        </div>
                    )}
                    {order?.voucherActivation && (
                        <div className="row">
                            <span>کد فعالساز ووچر</span>
                            <p>{order?.voucherActivation}</p>
                        </div>
                    )}
                    {order?.batchNumber ? (
                        <div className="row">
                            <span>بچ نامبر</span>
                            <p className="en long-text">
                                <CopyOutlined onClick={() => copyToClipboard(order?.batchNumber, 'بچ نامبر')} />
                                {order?.batchNumber}
                            </p>
                        </div>
                    ) : (
                        <></>
                    )}
                    {txId && (
                        <div className="row">
                            <span>tx-id</span>
                            <p className="en long-text" title={txId}>
                                <CopyOutlined onClick={() => copyToClipboard(txId, 'هش تراکنش')} />
                                {txId}
                            </p>
                        </div>
                    )}
                    {order?.digitalRecept && (
                        <div className="row text-overflow copy">
                            <span>رسید دیجیتالی</span>
                            <p>
                                <CopyOutlined onClick={() => copyToClipboard(order?.digitalRecept, 'رسید دیجیتالی')} />
                                {order?.digitalRecept}
                            </p>
                        </div>
                    )}
                    {order?.iBan && (
                        <div className="row">
                            <span>شماره شبا</span>
                            <p>{order?.iBan}</p>
                        </div>
                    )}
                    {order?.destinationWalletAddress && (
                        <div className="row">
                            <span>آدرس کیف پول</span>
                            <p className="en">{order?.destinationWalletAddress}</p>
                        </div>
                    )}
                    {selectedRow.fullName.replaceAll(' ', '') !== '' ? (
                        <div className="row">
                            <span>نام کامل کاربر</span>
                            <p><UserLink userId={selectedRow.userId}>{selectedRow.fullName}</UserLink>{selectedRow.hasApprovedSelfie ?
                                <CheckCircleTwoTone twoToneColor="#52c41a" /> :
                                <CloseCircleTwoTone twoToneColor={"red"} />}</p>
                        </div>
                    ) : (
                        <div className="row">
                            <span>نام کاربری</span>
                            <p><CopyablePhone phoneNumber={selectedRow.phoneNumber} /></p>
                        </div>
                    )}
                    <div className="row">
                        <span>نوع سفارش</span>
                        <p>
                            {order?.sourceSymbol == 'IRT'
                                ? 'خرید'
                                : order?.destinationSymbol == 'IRT'
                                    ? 'فروش'
                                    : 'تبدیل'}
                        </p>
                    </div>
                    {order?.destinationMoneyAccount && (
                        <div className="row">
                            <span>اکانت ارز مقصد</span>
                            <p>{order?.destinationMoneyAccount}</p>
                        </div>
                    )}
                    <div className="row">
                        <span>تاریخ و زمان سفارش</span>
                        <p>
                            {moment.utc(order?.creationDate).local().locale('fa').format('YYYY/MM/DD')} |{' '}
                            {moment.utc(order?.creationDate).local().locale('fa').format('HH:mm')}
                        </p>
                    </div>
                    {(order?.orderTransactionState?.id === 9 || order?.orderTransactionState?.id === 10) && (
                        <div className="row">
                            <span>زمان باقی مانده تا واریز</span>
                            <Countdown value={timer} />
                            {timer}
                        </div>
                    )}
                    <div className="row">
                        <span>وضعیت</span>
                        <p>
                            <Badge
                                text={order?.orderTransactionState?.title}
                                type={
                                    order?.orderTransactionState?.title.includes('کنسل شده') ||
                                        order?.orderTransactionState?.title.includes('ناموفق')
                                        ? 'error'
                                        : order?.orderTransactionState?.title.includes('در حال') ||
                                            order?.orderTransactionState.title.includes('انتظار')
                                            ? 'waiting'
                                            : order?.orderTransactionState?.title.includes('نشده')
                                                ? 'error'
                                                : 'success'
                                }
                            />
                        </p>
                    </div>
                </>
            )}
        </Modal>
    );
};
